import { AxiosResponse } from 'axios';
import {
  decoratorIsNotNullable,
  dynamicNamespace,
  equals,
  mergeFilters,
  orderBy,
  select,
} from 'utils/dynamic';
import { API, apiRtk, rtkAdapterDynamicToSource } from 'utils/service';
import { ICountry } from '__generated__/api';
import { IGridCountry } from './models';

const dynamic = dynamicNamespace<IGridCountry>();

const REVALIDATE_KEY = 'Countries';

type SourceHighlight = Pick<ICountry, 'id' | 'countryName' | 'flag' | 'isActive'>
export const apiCountries = apiRtk.injectEndpoints({
  endpoints: (build) => ({
    getSourceCountries: build.query<IGridCountry[], void>({
      queryFn: async () => {
        try {
          const { data } = await API.api.countriesGetAllDynamicCreate({
            select: dynamic.select('id', 'countryName as title'),
            orderBy: dynamic.orderBy('countryName', 'asc'),
          });
          return { data: data?.items || [] } as { data: IGridCountry[] };
        } catch (e: any) {
          return { error: e };
        }
      },
    }),
    getSourceHighlightCountries: build.query<Array<SourceHighlight>, void>({
      queryFn: async () => {
        try {
          const res = await API.api.countriesGetAllDynamicCreate({
            select: select('id', 'countryName', 'flag', 'isActive'),
            orderBy: orderBy('countryName', 'asc'),
            filter: mergeFilters(
              dynamic.makeFilter('highlight', true, decoratorIsNotNullable(equals)),
            ).join('&&'),
          });

          return rtkAdapterDynamicToSource(res) as AxiosResponse<
            Array<SourceHighlight>
          >;
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [{ type: REVALIDATE_KEY }],
    }),
  }),
});
